"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Adjust_1 = require("./Adjust");
exports.Adjust = Adjust_1.Adjust;
var Album_1 = require("./Album");
exports.Album = Album_1.Album;
var Ambulance_1 = require("./Ambulance");
exports.Ambulance = Ambulance_1.Ambulance;
var Archive_1 = require("./Archive");
exports.Archive = Archive_1.Archive;
var Area_1 = require("./Area");
exports.Area = Area_1.Area;
var Award_1 = require("./Award");
exports.Award = Award_1.Award;
var BadgeCheck_1 = require("./BadgeCheck");
exports.BadgeCheck = BadgeCheck_1.BadgeCheck;
var Badge_1 = require("./Badge");
exports.Badge = Badge_1.Badge;
var Ball_1 = require("./Ball");
exports.Ball = Ball_1.Ball;
var BarChartSquare_1 = require("./BarChartSquare");
exports.BarChartSquare = BarChartSquare_1.BarChartSquare;
var Barcode_1 = require("./Barcode");
exports.Barcode = Barcode_1.Barcode;
var Bath_1 = require("./Bath");
exports.Bath = Bath_1.Bath;
var BatteryCharging_1 = require("./BatteryCharging");
exports.BatteryCharging = BatteryCharging_1.BatteryCharging;
var BatteryFull_1 = require("./BatteryFull");
exports.BatteryFull = BatteryFull_1.BatteryFull;
var BatteryLow_1 = require("./BatteryLow");
exports.BatteryLow = BatteryLow_1.BatteryLow;
var Battery_1 = require("./Battery");
exports.Battery = Battery_1.Battery;
var Bed_1 = require("./Bed");
exports.Bed = Bed_1.Bed;
var BellOff_1 = require("./BellOff");
exports.BellOff = BellOff_1.BellOff;
var BellRing_1 = require("./BellRing");
exports.BellRing = BellRing_1.BellRing;
var Bell_1 = require("./Bell");
exports.Bell = Bell_1.Bell;
var Bolt_1 = require("./Bolt");
exports.Bolt = Bolt_1.Bolt;
var BookBookmark_1 = require("./BookBookmark");
exports.BookBookmark = BookBookmark_1.BookBookmark;
var BookOpen_1 = require("./BookOpen");
exports.BookOpen = BookOpen_1.BookOpen;
var Book_1 = require("./Book");
exports.Book = Book_1.Book;
var BookmarkPlus_1 = require("./BookmarkPlus");
exports.BookmarkPlus = BookmarkPlus_1.BookmarkPlus;
var BookmarkStar_1 = require("./BookmarkStar");
exports.BookmarkStar = BookmarkStar_1.BookmarkStar;
var Bookmark_1 = require("./Bookmark");
exports.Bookmark = Bookmark_1.Bookmark;
var Bot_1 = require("./Bot");
exports.Bot = Bot_1.Bot;
var Box_1 = require("./Box");
exports.Box = Box_1.Box;
var Briefcase_1 = require("./Briefcase");
exports.Briefcase = Briefcase_1.Briefcase;
var Brush_1 = require("./Brush");
exports.Brush = Brush_1.Brush;
var Bug_1 = require("./Bug");
exports.Bug = Bug_1.Bug;
var Building_1 = require("./Building");
exports.Building = Building_1.Building;
var Bulb_1 = require("./Bulb");
exports.Bulb = Bulb_1.Bulb;
var Buoy_1 = require("./Buoy");
exports.Buoy = Buoy_1.Buoy;
var Bus_1 = require("./Bus");
exports.Bus = Bus_1.Bus;
var Calculator_1 = require("./Calculator");
exports.Calculator = Calculator_1.Calculator;
var CameraOff_1 = require("./CameraOff");
exports.CameraOff = CameraOff_1.CameraOff;
var Camera_1 = require("./Camera");
exports.Camera = Camera_1.Camera;
var Capsule_1 = require("./Capsule");
exports.Capsule = Capsule_1.Capsule;
var Captions_1 = require("./Captions");
exports.Captions = Captions_1.Captions;
var Car_1 = require("./Car");
exports.Car = Car_1.Car;
var Card_1 = require("./Card");
exports.Card = Card_1.Card;
var CartAlt_1 = require("./CartAlt");
exports.CartAlt = CartAlt_1.CartAlt;
var Cart_1 = require("./Cart");
exports.Cart = Cart_1.Cart;
var Categories_1 = require("./Categories");
exports.Categories = Categories_1.Categories;
var Certification_1 = require("./Certification");
exports.Certification = Certification_1.Certification;
var Chart_1 = require("./Chart");
exports.Chart = Chart_1.Chart;
var CheckCircle_1 = require("./CheckCircle");
exports.CheckCircle = CheckCircle_1.CheckCircle;
var CheckboxChecked_1 = require("./CheckboxChecked");
exports.CheckboxChecked = CheckboxChecked_1.CheckboxChecked;
var Checkbox_1 = require("./Checkbox");
exports.Checkbox = Checkbox_1.Checkbox;
var Chip_1 = require("./Chip");
exports.Chip = Chip_1.Chip;
var CloudDownload_1 = require("./CloudDownload");
exports.CloudDownload = CloudDownload_1.CloudDownload;
var CloudUpload_1 = require("./CloudUpload");
exports.CloudUpload = CloudUpload_1.CloudUpload;
var Cloud_1 = require("./Cloud");
exports.Cloud = Cloud_1.Cloud;
var CoffeeAlt_1 = require("./CoffeeAlt");
exports.CoffeeAlt = CoffeeAlt_1.CoffeeAlt;
var Coffee_1 = require("./Coffee");
exports.Coffee = Coffee_1.Coffee;
var Cog_1 = require("./Cog");
exports.Cog = Cog_1.Cog;
var Collection_1 = require("./Collection");
exports.Collection = Collection_1.Collection;
var ColorFill_1 = require("./ColorFill");
exports.ColorFill = ColorFill_1.ColorFill;
var Contact_1 = require("./Contact");
exports.Contact = Contact_1.Contact;
var Conversation_1 = require("./Conversation");
exports.Conversation = Conversation_1.Conversation;
var Copy_1 = require("./Copy");
exports.Copy = Copy_1.Copy;
var Coupon_1 = require("./Coupon");
exports.Coupon = Coupon_1.Coupon;
var Crown_1 = require("./Crown");
exports.Crown = Crown_1.Crown;
var Cube_1 = require("./Cube");
exports.Cube = Cube_1.Cube;
var Dashboard_1 = require("./Dashboard");
exports.Dashboard = Dashboard_1.Dashboard;
var Detail_1 = require("./Detail");
exports.Detail = Detail_1.Detail;
var Direction_1 = require("./Direction");
exports.Direction = Direction_1.Direction;
var Directions_1 = require("./Directions");
exports.Directions = Directions_1.Directions;
var Disc_1 = require("./Disc");
exports.Disc = Disc_1.Disc;
var Discount_1 = require("./Discount");
exports.Discount = Discount_1.Discount;
var Dislike_1 = require("./Dislike");
exports.Dislike = Dislike_1.Dislike;
var DockBottom_1 = require("./DockBottom");
exports.DockBottom = DockBottom_1.DockBottom;
var DockLeft_1 = require("./DockLeft");
exports.DockLeft = DockLeft_1.DockLeft;
var DockRight_1 = require("./DockRight");
exports.DockRight = DockRight_1.DockRight;
var DockTop_1 = require("./DockTop");
exports.DockTop = DockTop_1.DockTop;
var DollarCircle_1 = require("./DollarCircle");
exports.DollarCircle = DollarCircle_1.DollarCircle;
var DownArrowCircle_1 = require("./DownArrowCircle");
exports.DownArrowCircle = DownArrowCircle_1.DownArrowCircle;
var DownArrowSquare_1 = require("./DownArrowSquare");
exports.DownArrowSquare = DownArrowSquare_1.DownArrowSquare;
var Download_1 = require("./Download");
exports.Download = Download_1.Download;
var Downvote_1 = require("./Downvote");
exports.Downvote = Downvote_1.Downvote;
var Drink_1 = require("./Drink");
exports.Drink = Drink_1.Drink;
var Droplet_1 = require("./Droplet");
exports.Droplet = Droplet_1.Droplet;
var Duplicate_1 = require("./Duplicate");
exports.Duplicate = Duplicate_1.Duplicate;
var Edit_1 = require("./Edit");
exports.Edit = Edit_1.Edit;
var Eject_1 = require("./Eject");
exports.Eject = Eject_1.Eject;
var Envelope_1 = require("./Envelope");
exports.Envelope = Envelope_1.Envelope;
var Eraser_1 = require("./Eraser");
exports.Eraser = Eraser_1.Eraser;
var ErrorCircle_1 = require("./ErrorCircle");
exports.ErrorCircle = ErrorCircle_1.ErrorCircle;
var Error_1 = require("./Error");
exports.Error = Error_1.Error;
var Eyedropper_1 = require("./Eyedropper");
exports.Eyedropper = Eyedropper_1.Eyedropper;
var Factory_1 = require("./Factory");
exports.Factory = Factory_1.Factory;
var FileBlank_1 = require("./FileBlank");
exports.FileBlank = FileBlank_1.FileBlank;
var FileImage_1 = require("./FileImage");
exports.FileImage = FileImage_1.FileImage;
var FilePlus_1 = require("./FilePlus");
exports.FilePlus = FilePlus_1.FilePlus;
var File_1 = require("./File");
exports.File = File_1.File;
var Film_1 = require("./Film");
exports.Film = Film_1.Film;
var FilterAlt_1 = require("./FilterAlt");
exports.FilterAlt = FilterAlt_1.FilterAlt;
var FirstAid_1 = require("./FirstAid");
exports.FirstAid = FirstAid_1.FirstAid;
var FlagAlt_1 = require("./FlagAlt");
exports.FlagAlt = FlagAlt_1.FlagAlt;
var Flag_1 = require("./Flag");
exports.Flag = Flag_1.Flag;
var Flame_1 = require("./Flame");
exports.Flame = Flame_1.Flame;
var Flask_1 = require("./Flask");
exports.Flask = Flask_1.Flask;
var FolderOpen_1 = require("./FolderOpen");
exports.FolderOpen = FolderOpen_1.FolderOpen;
var FolderPlus_1 = require("./FolderPlus");
exports.FolderPlus = FolderPlus_1.FolderPlus;
var Folder_1 = require("./Folder");
exports.Folder = Folder_1.Folder;
var GasPump_1 = require("./GasPump");
exports.GasPump = GasPump_1.GasPump;
var Gift_1 = require("./Gift");
exports.Gift = Gift_1.Gift;
var GridAlt_1 = require("./GridAlt");
exports.GridAlt = GridAlt_1.GridAlt;
var Group_1 = require("./Group");
exports.Group = Group_1.Group;
var Hdd_1 = require("./Hdd");
exports.Hdd = Hdd_1.Hdd;
var Heart_1 = require("./Heart");
exports.Heart = Heart_1.Heart;
var HelpCircle_1 = require("./HelpCircle");
exports.HelpCircle = HelpCircle_1.HelpCircle;
var Hide_1 = require("./Hide");
exports.Hide = Hide_1.Hide;
var Home_1 = require("./Home");
exports.Home = Home_1.Home;
var Hot_1 = require("./Hot");
exports.Hot = Hot_1.Hot;
var Hotel_1 = require("./Hotel");
exports.Hotel = Hotel_1.Hotel;
var Hourglass_1 = require("./Hourglass");
exports.Hourglass = Hourglass_1.Hourglass;
var ImageAlt_1 = require("./ImageAlt");
exports.ImageAlt = ImageAlt_1.ImageAlt;
var Image_1 = require("./Image");
exports.Image = Image_1.Image;
var Inbox_1 = require("./Inbox");
exports.Inbox = Inbox_1.Inbox;
var InfoCircle_1 = require("./InfoCircle");
exports.InfoCircle = InfoCircle_1.InfoCircle;
var JoystickAlt_1 = require("./JoystickAlt");
exports.JoystickAlt = JoystickAlt_1.JoystickAlt;
var JoystickButton_1 = require("./JoystickButton");
exports.JoystickButton = JoystickButton_1.JoystickButton;
var Joystick_1 = require("./Joystick");
exports.Joystick = Joystick_1.Joystick;
var Key_1 = require("./Key");
exports.Key = Key_1.Key;
var Keyboard_1 = require("./Keyboard");
exports.Keyboard = Keyboard_1.Keyboard;
var Landmark_1 = require("./Landmark");
exports.Landmark = Landmark_1.Landmark;
var Layer_1 = require("./Layer");
exports.Layer = Layer_1.Layer;
var LeftArrowCircle_1 = require("./LeftArrowCircle");
exports.LeftArrowCircle = LeftArrowCircle_1.LeftArrowCircle;
var LeftArrowSquare_1 = require("./LeftArrowSquare");
exports.LeftArrowSquare = LeftArrowSquare_1.LeftArrowSquare;
var Like_1 = require("./Like");
exports.Like = Like_1.Like;
var LockOpen_1 = require("./LockOpen");
exports.LockOpen = LockOpen_1.LockOpen;
var Lock_1 = require("./Lock");
exports.Lock = Lock_1.Lock;
var MagicWand_1 = require("./MagicWand");
exports.MagicWand = MagicWand_1.MagicWand;
var Magnet_1 = require("./Magnet");
exports.Magnet = Magnet_1.Magnet;
var MapAlt_1 = require("./MapAlt");
exports.MapAlt = MapAlt_1.MapAlt;
var Map_1 = require("./Map");
exports.Map = Map_1.Map;
var Megaphone_1 = require("./Megaphone");
exports.Megaphone = Megaphone_1.Megaphone;
var MessageRounded_1 = require("./MessageRounded");
exports.MessageRounded = MessageRounded_1.MessageRounded;
var Message_1 = require("./Message");
exports.Message = Message_1.Message;
var MicrophoneAlt_1 = require("./MicrophoneAlt");
exports.MicrophoneAlt = MicrophoneAlt_1.MicrophoneAlt;
var MicrophoneOff_1 = require("./MicrophoneOff");
exports.MicrophoneOff = MicrophoneOff_1.MicrophoneOff;
var Microphone_1 = require("./Microphone");
exports.Microphone = Microphone_1.Microphone;
var MinusCircle_1 = require("./MinusCircle");
exports.MinusCircle = MinusCircle_1.MinusCircle;
var MinusSquare_1 = require("./MinusSquare");
exports.MinusSquare = MinusSquare_1.MinusSquare;
var Moon_1 = require("./Moon");
exports.Moon = Moon_1.Moon;
var Mouse_1 = require("./Mouse");
exports.Mouse = Mouse_1.Mouse;
var Movie_1 = require("./Movie");
exports.Movie = Movie_1.Movie;
var Music_1 = require("./Music");
exports.Music = Music_1.Music;
var Navigation_1 = require("./Navigation");
exports.Navigation = Navigation_1.Navigation;
var News_1 = require("./News");
exports.News = News_1.News;
var Note_1 = require("./Note");
exports.Note = Note_1.Note;
var Package_1 = require("./Package");
exports.Package = Package_1.Package;
var PaperPlane_1 = require("./PaperPlane");
exports.PaperPlane = PaperPlane_1.PaperPlane;
var Paste_1 = require("./Paste");
exports.Paste = Paste_1.Paste;
var Pen_1 = require("./Pen");
exports.Pen = Pen_1.Pen;
var Pencil_1 = require("./Pencil");
exports.Pencil = Pencil_1.Pencil;
var PhoneCall_1 = require("./PhoneCall");
exports.PhoneCall = PhoneCall_1.PhoneCall;
var PhoneIncoming_1 = require("./PhoneIncoming");
exports.PhoneIncoming = PhoneIncoming_1.PhoneIncoming;
var PhoneOutgoing_1 = require("./PhoneOutgoing");
exports.PhoneOutgoing = PhoneOutgoing_1.PhoneOutgoing;
var Phone_1 = require("./Phone");
exports.Phone = Phone_1.Phone;
var PhotoAlbum_1 = require("./PhotoAlbum");
exports.PhotoAlbum = PhotoAlbum_1.PhotoAlbum;
var PieChart_1 = require("./PieChart");
exports.PieChart = PieChart_1.PieChart;
var Pin_1 = require("./Pin");
exports.Pin = Pin_1.Pin;
var Plane_1 = require("./Plane");
exports.Plane = Plane_1.Plane;
var Planet_1 = require("./Planet");
exports.Planet = Planet_1.Planet;
var Playlist_1 = require("./Playlist");
exports.Playlist = Playlist_1.Playlist;
var Plug_1 = require("./Plug");
exports.Plug = Plug_1.Plug;
var PlusCircle_1 = require("./PlusCircle");
exports.PlusCircle = PlusCircle_1.PlusCircle;
var PlusSquare_1 = require("./PlusSquare");
exports.PlusSquare = PlusSquare_1.PlusSquare;
var Printer_1 = require("./Printer");
exports.Printer = Printer_1.Printer;
var PurchaseTag_1 = require("./PurchaseTag");
exports.PurchaseTag = PurchaseTag_1.PurchaseTag;
var QuoteLeft_1 = require("./QuoteLeft");
exports.QuoteLeft = QuoteLeft_1.QuoteLeft;
var QuoteRight_1 = require("./QuoteRight");
exports.QuoteRight = QuoteRight_1.QuoteRight;
var Radio_1 = require("./Radio");
exports.Radio = Radio_1.Radio;
var Rename_1 = require("./Rename");
exports.Rename = Rename_1.Rename;
var Report_1 = require("./Report");
exports.Report = Report_1.Report;
var RightArrowCircle_1 = require("./RightArrowCircle");
exports.RightArrowCircle = RightArrowCircle_1.RightArrowCircle;
var RightArrowSquare_1 = require("./RightArrowSquare");
exports.RightArrowSquare = RightArrowSquare_1.RightArrowSquare;
var Rocket_1 = require("./Rocket");
exports.Rocket = Rocket_1.Rocket;
var Ruler_1 = require("./Ruler");
exports.Ruler = Ruler_1.Ruler;
var Save_1 = require("./Save");
exports.Save = Save_1.Save;
var SelectMultiple_1 = require("./SelectMultiple");
exports.SelectMultiple = SelectMultiple_1.SelectMultiple;
var Send_1 = require("./Send");
exports.Send = Send_1.Send;
var Server_1 = require("./Server");
exports.Server = Server_1.Server;
var Share_1 = require("./Share");
exports.Share = Share_1.Share;
var Shield_1 = require("./Shield");
exports.Shield = Shield_1.Shield;
var Ship_1 = require("./Ship");
exports.Ship = Ship_1.Ship;
var ShoppingBagAlt_1 = require("./ShoppingBagAlt");
exports.ShoppingBagAlt = ShoppingBagAlt_1.ShoppingBagAlt;
var ShareAlt_1 = require("./ShareAlt");
exports.ShareAlt = ShareAlt_1.ShareAlt;
var ShoppingBag_1 = require("./ShoppingBag");
exports.ShoppingBag = ShoppingBag_1.ShoppingBag;
var Show_1 = require("./Show");
exports.Show = Show_1.Show;
var Skull_1 = require("./Skull");
exports.Skull = Skull_1.Skull;
var SmileyHappy_1 = require("./SmileyHappy");
exports.SmileyHappy = SmileyHappy_1.SmileyHappy;
var SmileyMeh_1 = require("./SmileyMeh");
exports.SmileyMeh = SmileyMeh_1.SmileyMeh;
var SmileySad_1 = require("./SmileySad");
exports.SmileySad = SmileySad_1.SmileySad;
var SortAlt_1 = require("./SortAlt");
exports.SortAlt = SortAlt_1.SortAlt;
var Spreadsheet_1 = require("./Spreadsheet");
exports.Spreadsheet = Spreadsheet_1.Spreadsheet;
var StarHalf_1 = require("./StarHalf");
exports.StarHalf = StarHalf_1.StarHalf;
var Star_1 = require("./Star");
exports.Star = Star_1.Star;
var Sun_1 = require("./Sun");
exports.Sun = Sun_1.Sun;
var TShirt_1 = require("./TShirt");
exports.TShirt = TShirt_1.TShirt;
var TagX_1 = require("./TagX");
exports.TagX = TagX_1.TagX;
var Tag_1 = require("./Tag");
exports.Tag = Tag_1.Tag;
var Taxi_1 = require("./Taxi");
exports.Taxi = Taxi_1.Taxi;
var TennisBall_1 = require("./TennisBall");
exports.TennisBall = TennisBall_1.TennisBall;
var Terminal_1 = require("./Terminal");
exports.Terminal = Terminal_1.Terminal;
var Thermometer_1 = require("./Thermometer");
exports.Thermometer = Thermometer_1.Thermometer;
var ToTop_1 = require("./ToTop");
exports.ToTop = ToTop_1.ToTop;
var ToggleLeft_1 = require("./ToggleLeft");
exports.ToggleLeft = ToggleLeft_1.ToggleLeft;
var ToggleRight_1 = require("./ToggleRight");
exports.ToggleRight = ToggleRight_1.ToggleRight;
var Torch_1 = require("./Torch");
exports.Torch = Torch_1.Torch;
var Train_1 = require("./Train");
exports.Train = Train_1.Train;
var TrashAlt_1 = require("./TrashAlt");
exports.TrashAlt = TrashAlt_1.TrashAlt;
var Trash_1 = require("./Trash");
exports.Trash = Trash_1.Trash;
var Tree_1 = require("./Tree");
exports.Tree = Tree_1.Tree;
var Trophy_1 = require("./Trophy");
exports.Trophy = Trophy_1.Trophy;
var Truck_1 = require("./Truck");
exports.Truck = Truck_1.Truck;
var UpArrowCircle_1 = require("./UpArrowCircle");
exports.UpArrowCircle = UpArrowCircle_1.UpArrowCircle;
var UpArrowSquare_1 = require("./UpArrowSquare");
exports.UpArrowSquare = UpArrowSquare_1.UpArrowSquare;
var Upvote_1 = require("./Upvote");
exports.Upvote = Upvote_1.Upvote;
var UserBadge_1 = require("./UserBadge");
exports.UserBadge = UserBadge_1.UserBadge;
var UserCircle_1 = require("./UserCircle");
exports.UserCircle = UserCircle_1.UserCircle;
var UserDetail_1 = require("./UserDetail");
exports.UserDetail = UserDetail_1.UserDetail;
var UserMinus_1 = require("./UserMinus");
exports.UserMinus = UserMinus_1.UserMinus;
var UserPlus_1 = require("./UserPlus");
exports.UserPlus = UserPlus_1.UserPlus;
var UserRectangle_1 = require("./UserRectangle");
exports.UserRectangle = UserRectangle_1.UserRectangle;
var User_1 = require("./User");
exports.User = User_1.User;
var VideoOff_1 = require("./VideoOff");
exports.VideoOff = VideoOff_1.VideoOff;
var VideoPlus_1 = require("./VideoPlus");
exports.VideoPlus = VideoPlus_1.VideoPlus;
var Video_1 = require("./Video");
exports.Video = Video_1.Video;
var Videos_1 = require("./Videos");
exports.Videos = Videos_1.Videos;
var VolumeFull_1 = require("./VolumeFull");
exports.VolumeFull = VolumeFull_1.VolumeFull;
var VolumeLow_1 = require("./VolumeLow");
exports.VolumeLow = VolumeLow_1.VolumeLow;
var VolumeMute_1 = require("./VolumeMute");
exports.VolumeMute = VolumeMute_1.VolumeMute;
var Volume_1 = require("./Volume");
exports.Volume = Volume_1.Volume;
var Wallet_1 = require("./Wallet");
exports.Wallet = Wallet_1.Wallet;
var WatchAlt_1 = require("./WatchAlt");
exports.WatchAlt = WatchAlt_1.WatchAlt;
var Watch_1 = require("./Watch");
exports.Watch = Watch_1.Watch;
var Widget_1 = require("./Widget");
exports.Widget = Widget_1.Widget;
var Wrench_1 = require("./Wrench");
exports.Wrench = Wrench_1.Wrench;
var XCircle_1 = require("./XCircle");
exports.XCircle = XCircle_1.XCircle;
var XSquare_1 = require("./XSquare");
exports.XSquare = XSquare_1.XSquare;
var YinYang_1 = require("./YinYang");
exports.YinYang = YinYang_1.YinYang;
var Zap_1 = require("./Zap");
exports.Zap = Zap_1.Zap;
